import FeedbackModalContainer from './FeedbackModalContainer';
import FeedbackPanelContainer from './FeedbackPanelContainer';

globalThis.Survey = {
  FeedbackModalContainer: FeedbackModalContainer,
  FeedbackPanelContainer: FeedbackPanelContainer,
};
